import { render, staticRenderFns } from "./veStuHygieneStudentEdit.vue?vue&type=template&id=5546d172&scoped=true"
import script from "./veStuHygieneStudentEdit.vue?vue&type=script&lang=js"
export * from "./veStuHygieneStudentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546d172",
  null
  
)

export default component.exports